import React, { useState, useEffect } from "react";

import { dataProcess } from "../../../api/index.js";
import { parserAPI } from "../../../utils/parser.jsx";
import { useNavigate } from "react-router-dom";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";

function App({ selectedStatus }) {
  const {
    selectedLocationOverview,
    selectedMachineOverview,
    dateRangeOverview,
  } = useDashboardContext();
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const navigate = useNavigate();
  const navigatePage = (url) => {
    navigate(url);
  };

  const [data, setData] = useState(null);
  const [allMachines, setAllMachines] = useState([]);
  const colors = [themeColor];
  const getData = async () => {
    const res = await dataProcess.alertCountPerMachine("Location", {
      location_id: selectedLocationOverview ? selectedLocationOverview : "",
      machine_id: selectedMachineOverview ? selectedMachineOverview : "",
      start_date: dateRangeOverview?.startDate
        ? dateRangeOverview?.startDate
        : "",
      end_date: dateRangeOverview?.endDate ? dateRangeOverview?.endDate : "",
    });
    const datas = await parserAPI(res);
    const machines = datas.machines;
    let filtered = machines.filter(
      (m) => m.alertCount > 0 && m.machine_status !== "Archived"
    );
    setData(filtered);
    setAllMachines(filtered);
  };

  useEffect(() => {
    getData();
  }, [selectedLocationOverview, selectedMachineOverview, dateRangeOverview]);

  useEffect(() => {
    console.log({ selectedStatus, allMachines });
    if (selectedStatus) {
      const filtered = allMachines.filter((m) => {
        return m.alert.find((al) => al.alert_status === selectedStatus);
      });
      setData(filtered);
    } else {
      setData(allMachines);
    }
  }, [selectedStatus]);
  // labels will be the date of data source if it exist only one date in the label

  return data ? (
    <div className="table-responsive">
      <table className="table table-striped table-borderless mb-2px small text-nowrap tr-hover">
        <thead>
          <tr>
            <th>Machine</th>
            <th>Total Alarm</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((machine, index) => (
            <tr key={index}>
              <td>
                <span className="d-flex align-items-center">
                  <i className={"bi bi-circle-fill fs-6px me-2 text-theme"}></i>
                  {machine.machine_name}
                </span>
              </td>
              <td>
                <span
                  className={
                    "badge d-block rounded-0 pt-5px w-70px  text-white"
                  }
                >
                  {machine.alertCount}
                </span>
              </td>
              <td>
                <a
                  className="text-decoration-none text-inverse btn btn-danger btn-sm"
                  style={{
                    marginLeft: "5px",
                    fontSize: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    navigatePage("/alarm/detail/" + machine.latest_alert)
                  }
                >
                  <i className="bi bi-search"></i> Alarm
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
